export default __webpack_public_path__ + "static/media/alert-success.1b1b37b2.svg";